export enum enumTransportationMode {
  OCEAN = 11,
  AIR = 40,
  RAIL = 21,
  TRUCK = 30,
}
